export default __webpack_public_path__ + "static/media/warning_compliance_rule.b3976323.svg";